import { render, staticRenderFns } from "./ClientEmploymentRestHandler.vue?vue&type=template&id=3c61cc14&scoped=true&"
import script from "./ClientEmploymentRestHandler.vue?vue&type=script&lang=js&"
export * from "./ClientEmploymentRestHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c61cc14",
  null
  
)

export default component.exports